/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApplicationMigrationStatus {
    Available = 'Available',
    NotAvailable = 'NotAvailable'
}


export function instanceOfApplicationMigrationStatus(value: any): boolean {
    for (const key in ApplicationMigrationStatus) {
        if (Object.prototype.hasOwnProperty.call(ApplicationMigrationStatus, key)) {
            if (ApplicationMigrationStatus[key as keyof typeof ApplicationMigrationStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApplicationMigrationStatusFromJSON(json: any): ApplicationMigrationStatus {
    return ApplicationMigrationStatusFromJSONTyped(json, false);
}

export function ApplicationMigrationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationMigrationStatus {
    return json as ApplicationMigrationStatus;
}

export function ApplicationMigrationStatusToJSON(value?: ApplicationMigrationStatus | null): any {
    return value as any;
}

export function ApplicationMigrationStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ApplicationMigrationStatus {
    return value as ApplicationMigrationStatus;
}

